import { render, staticRenderFns } from "./ProjectListProjectLeaders.vue?vue&type=template&id=186769cb&"
import script from "./ProjectListProjectLeaders.vue?vue&type=script&lang=js&"
export * from "./ProjectListProjectLeaders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('186769cb')) {
      api.createRecord('186769cb', component.options)
    } else {
      api.reload('186769cb', component.options)
    }
    module.hot.accept("./ProjectListProjectLeaders.vue?vue&type=template&id=186769cb&", function () {
      api.rerender('186769cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/ProjectListProjectLeaders.vue"
export default component.exports